<template>
  <ElDialog
    class="column-settings-modal"
    :visible="value"
    :title="$t('ADVERTISEMENT.BIDS.CHANGE_COLUMN')"
    width="40%"
    append-to-body
    @close="revertAndClose"
  >
    <div class="row">
      <div
        class="column-settings-modal__draggable-column columns large-6 medium-6 small-12"
      >
        <div class="column-settings-modal__draggable-wrapper">
          <div class="column-settings-modal__column-title">
            {{ $t('ADVERTISEMENT.BIDS.SELECTED_COLUMNS') }}
          </div>
          <KeywordColumnSettingsItem
            v-for="column in lockedColumns"
            :key="column.property"
            class="column-settings-modal__fix-item"
            :column-name="column.label"
            is-locked
          />
          <Draggable
            v-model="internalVisibleColumns"
            group="columns"
            class="column-settings-modal__draggable"
          >
            <KeywordColumnSettingsItem
              v-for="column in internalVisibleColumns"
              :key="column.property"
              class="column-settings-modal__draggable-item"
              :column-name="column.label"
            />
          </Draggable>
        </div>
      </div>
      <div
        class="column-settings-modal__draggable-column columns large-6 medium-6 small-12"
      >
        <div class="column-settings-modal__draggable-wrapper">
          <div class="column-settings-modal__column-title">
            {{ $t('ADVERTISEMENT.BIDS.HIDDEN_COLUMNS') }}
          </div>
          <Draggable
            v-model="internalHiddenColumns"
            group="columns"
            class="column-settings-modal__draggable"
          >
            <KeywordColumnSettingsItem
              v-for="column in internalHiddenColumns"
              :key="column.componentName"
              class="column-settings-modal__draggable-item"
              :column-name="column.label"
            />
          </Draggable>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <ElButton
        type="primary"
        native-type="submit"
        size="large"
        @click="emitAndClose"
      >
        {{ $t('SAVE') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import Draggable from 'vuedraggable';

import dragndrop from '@/directives/dragndrop';

import KeywordColumnSettingsItem from './KeywordColumnSettingsItem';

export default {
  name: 'ColumnSettingsModal',

  components: {
    Draggable,
    KeywordColumnSettingsItem,
  },
  directives: {
    dragndrop,
  },
  props: {
    value: Boolean,
    visibleColumns: {
      type: Array,
      required: true,
    },
    hiddenColumns: {
      type: Array,
      required: true,
    },
    lockedColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalVisibleColumns: [],
      internalHiddenColumns: [],
    };
  },
  watch: {
    visibleColumns: {
      immediate: true,
      handler() {
        this.internalVisibleColumns = [...this.visibleColumns];
      },
    },
    hiddenColumns: {
      immediate: true,
      handler() {
        this.internalHiddenColumns = [...this.hiddenColumns];
      },
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    revertAndClose() {
      this.close();
      this.revert();
    },
    revert() {
      this.internalVisibleColumns = [...this.visibleColumns];
      this.internalHiddenColumns = [...this.hiddenColumns];
    },
    emitAndClose() {
      this.$emit('update:visible-columns', this.internalVisibleColumns);
      this.$emit('update:hidden-columns', this.internalHiddenColumns);
      this.close();
    },
  },
};
</script>

<style lang="scss">
.column-settings-modal {
  &__column-title {
    text-align: center;
    margin-bottom: $global-margin;
    font-weight: bold;
  }

  &__draggable-column:not(:last-child) {
    border-right: 1px solid #eee;
    @include rtl() {
      border-right: 0;
      border-left: 1px solid #eee;
    }

    @include breakpoint(small down) {
      margin-bottom: $global-margin;

      border: 0;
    }
  }

  &__draggable-wrapper {
    display: flex;
    flex-direction: column;

    height: 100%;
  }

  &__draggable {
    flex: 1;
  }

  &__draggable-item {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    &:not(:last-child) {
      margin-bottom: $global-margin;
    }

    &--disabled {
      cursor: not-allowed;

      &:active {
        cursor: not-allowed;
      }
    }
  }

  &__fix-item {
    margin-bottom: $global-margin;
  }
}
</style>
